import { useLoginModal } from "@/context/LoginModalContext";
import { usePassportProvider } from "@/context/PassportProvider";
import { Suspense } from "react";
import { LoadingModal } from "../core/LoadingModal";
import { GenericBonusModal } from "./GemBonusModal";
import { useBonus } from "./useGemBonus";

const GemBonusContent = () => {
  const { bonusModalState, setBonusModalState, bonusDetails } = useBonus();

  const { openLoginModal } = useLoginModal();

  const { isLoggingIn } = usePassportProvider();

  return (
    <>
      {bonusModalState !== undefined ? (
        <GenericBonusModal
          bonusDetails={bonusDetails}
          state={bonusModalState}
          onLogin={openLoginModal}
          onClose={() => setBonusModalState(undefined)}
        />
      ) : null}
      <LoadingModal
        loading={isLoggingIn}
        text={[
          "Signing In...",
          "Waiting for login in a separate window (Close to try another method)",
        ]}
        closeable={true}
        loopingText={false}
      />
    </>
  );
};

export const GemBonus = () => {
  return (
    <Suspense fallback={null}>
      <GemBonusContent />
    </Suspense>
  );
};
